import { createContext } from "react";

const TopMenuBar = createContext([]);

export default TopMenuBar;